const mafos = {
    de: [{
        q: 'Was hat dich zum Kauf bewegt?',
        g: 0,
        a: [
            'Die Aktion hat mich überzeugt',
            'Der Preis ist überzeugend',
            'Der Geschmack ist überzeugend'
        ]
    }, {
        q: 'Wie bist du auf die Aktion aufmerksam geworden?',
        g: 1,
        a: [
            'Ich bin über die HARIBO-Website aufmerksam geworden',
            'Ich bin über die HARIBO-Social Media Kanäle aufmerksam geworden',
            'Ich bin beim Einkaufen auf die Aktion aufmerksam geworden',
            'Freunde/Bekannte haben mir von der Aktion erzählt',
            'Ich bin durch einen Handzettel/ein Prospekt auf die Aktion aufmerksam geworden'
        ]
    }, {
        q: 'Wie attraktiv findest du die Gewinne?',
        g: 2,
        a: [
            'Sehr attraktiv',
            'Eher attraktiv',
            'Wenig attraktiv',
            'Gar nicht attraktiv',
        ]
    }, {
        q: 'Hast du in der Vergangenheit schon mal bei einer HARIBO-Aktion mitgemacht?',
        g: 3,
        a: [
            'Ja',
            'Nein',
            'Weiß nicht',
        ]
    }, {
        q: 'Bitte gib dein ungefähres Alter an:',
        g: 4,
        a: [
            'Unter 18 Jahre',
            '18 bis 29 Jahre',
            '30 bis 54 Jahre',
            '55 Jahre oder älter ',
        ]
    }, {
        q: 'Wie viele Kinder zwischen 4 und 14 Jahren hast du, die in deinem Haushalt leben?',
        g: 5,
        a: [
            'Keine Kinder',
            '1 Kind',
            '2 Kinder',
            '3 Kinder',
            '4 Kinder oder mehr ',
        ]
    }],
    fr: [{
        q: "Qu'est-ce qui t'a poussé à acheter ?",
        g: 0,
        a: [
            "L'action m'a convaincu/e",
            "Le prix est convaincant",
            "Le goût est convaincant"
        ]
    }, {
        q: "Comment as-tu pris connaissance de l'action ?",
        g: 1,
        a: [
            "J'ai la découvert sur le site Internet de HARIBO.",
            "J'ai été rendu attentif à l'action via les canaux de médias sociaux HARIBO.",
            "J'ai la découvert en faisant mes courses.",
            "Des amis/connaissances m'ont parlé de l'action.",
            "J'ai pris connaissance de l'action par un prospectus/un dépliant."
        ]
    }, {
        q: "Trouvez-vous les prix intéressants ?",
        g: 2,
        a: [
            "Très attractif",
            "Plutôt attractif",
            "Peu attractif",
            "Pas du tout attractif"
        ]
    }, {
        q: "Avez-vous déjà participé à un jeu-concours HARIBO par le passé ?",
        g: 3,
        a: [
            'Oui',
            'Non',
            'Je ne sais pas'
        ]
    }, {
        q: "Veuillez indiquer ton âge approximatif:",
        g: 4,
        a: [
            'Moins de 18 ans',
            '18 à 29 ans',
            '30 à 54 ans',
            '55 ans ou plus'
        ]
    }, {
        q: "Combien d'enfants âgés de 4 à 14 ans vivent dans ton ménage ?",
        g: 5,
        a: [
            'Pas d\'enfants',
            '1 enfant',
            '2 enfants',
            '3 enfants',
            '4 enfants ou plus'
        ]
    }]
}

export default mafos;